import { render, staticRenderFns } from "./googleReview.vue?vue&type=template&id=2cc804b2&scoped=true"
import script from "./googleReview.vue?vue&type=script&lang=js"
export * from "./googleReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc804b2",
  null
  
)

export default component.exports